<!-- 富文本编辑组件封装 全功能 -->
<template>
  <div class="w_editor">
    <!-- 富文本编辑器 -->
    <div id="w_view"></div>
  </div>
</template>

<script lang="js">
// 引入富文本
import WE from "wangeditor";
// 引入elementUI Message模块（用于提示信息）
import { Message } from "element-ui";

export default {
  name: "WEditor",
  props: {
    // 默认值
    defaultText: { type: String },
    // 富文本更新的值
    richText: { type: String },
  },
  data() {
    return {
      // 编辑器实例
      editor: null,
      // 富文本菜单选项配置
      menuItem: [ 'head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'backColor', 'link', 'list', 'justify', 'quote', 'emoticon', 'image', 'table', 'splitLine', 'undo', 'redo' ],
    };
  },
  watch: {
    // 监听默认值
    defaultText(nv, ov) {
      if (nv != "") {
        this.editor.txt.html(nv);
        this.$emit("update:rich-text", nv);
      }
    },
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    // 初始化编辑器
    initEditor() {
      // 获取编辑器dom节点
      const editor = new WE("#w_view");
      // 配置编辑器
      editor.config.showLinkImg = false; /* 隐藏插入网络图片的功能 */
      editor.config.onchangeTimeout = 400; /* 配置触发 onchange 的时间频率，默认为 200ms */
      editor.config.uploadImgMaxLength = 1; /* 限制一次最多能传几张图片 */
      editor.config.showFullScreen = true; /* 配置全屏功能按钮是否展示 */
      editor.config.menus = [...this.menuItem]; /* 自定义系统菜单 */
      editor.config.uploadImgMaxSize = 2 * 1024 * 1024; /* 限制图片大小 5M*/
      editor.config.uploadImgServer = this.$baseUrl + '/file/upload'; // 图片上传接口
      editor.config.uploadFileName = "uploadFile"; // 自定义的文件名
      editor.config.uploadImgParams = { storagePath: 'picture' } // 图片上传自定义参数
      editor.config.customAlert = (err) => { Message.error(err); } // 自定义弹框提示
      editor.config.onchange = (newHtml) => { this.$emit("update:rich-text", newHtml) };// 监控变化，同步更新数据
      editor.config.uploadImgHooks = {
        // 上传图片之前，可阻止图片上传
        before: function(xhr) {},
        // 图片上传并返回了结果，图片插入已成功
        success: function(xhr) {},
        // 图片上传并返回了结果，但图片插入时出错了
        fail: function(xhr, editor, resData) {},
        // 上传图片出错，一般为 http 请求的错误
        error: function(xhr, editor, resData) {},
        // 上传图片超时
        timeout: function(xhr) {},
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert: function(insertImgFn, result) {
          insertImgFn(result.msg); // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
        }
      }
      // 创建编辑器
      editor.create();
      this.editor = editor;
    },
  },
  beforeDestroy() {
    // 销毁编辑器
    this.editor.destroy();
    this.editor = null;
  },
};
</script>